import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import * as GLOBAL from '../globals';
import { RecommendationReqParams } from '../types/RecommendationReqParams';

@Injectable()
export class CDSService {

    private baseURL = GLOBAL.cdsBaseURL;

    constructor(private http: HttpClient) { }

    public getStationInfo(stationID: string): Observable<any> {

        return this.http
            .get(this.baseURL + '/stationdata/station/' + stationID)
            .pipe(catchError(error => throwError(error)));
    }

    public getPublicSeasons(geoid: string, commodity: string): Observable<any> {

        return this.http
            .get(this.baseURL + '/season/seasons/commodity/' + commodity + '/pvt/false/geoid/' + geoid)
            .pipe(catchError(error => throwError(error)));
    }

    public getCurrentDiseaseStatus(season: string, disease: string, yesterday: string, today: string): Observable<any> {

        // Query example
        // season/seasonevent/diseasesimulation/observed/
        // season/59c873b38455bc1dbde3a00c/disease/59a81dee707cbe4640bfa8fd/from/2018-09-21/to/2018-09-21/select/last

        return this.http
            .get(this.baseURL + '/season/seasonevent/diseasesimulation/observed/season/' +
                season + '/disease/' + disease + '/from/' + yesterday + '/to/' + today + '/select/last/groupby/day')
            .pipe(catchError(error => throwError(error)));

    }

    public getDiseaseHistory(season: string, disease: string, from: string, to: string, group: boolean = true): Observable<any> {

        // Query example
        // season/seasonevent/diseasesimulation/observed/
        // season/59c8768d8455bc1dbde3a99e/disease/59a81dee707cbe4640bfa8fd/from/2018-08-21/to/2018-09-21/select/max/groupby/day

        return this.http
            .get(this.baseURL + '/season/seasonevent/diseasesimulation/observed/season/' +
                season + '/disease/' + disease + '/from/' + from + '/to/' + to + (group ? '/select/max/groupby/day' : ''))
            .pipe(catchError(error => throwError(error)));

    }

    public getDiseaseForecast(season: string, disease: string, from: string, to: string): Observable<any> {

        // Query example
        // season/seasonevent/diseasesimulation/observed/
        // season/59c8768d8455bc1dbde3a99e/disease/59a81dee707cbe4640bfa8fd/from/2018-08-21/to/2018-09-21/select/max/groupby/day

        return this.http
            .get(this.baseURL + '/season/seasonevent/diseasesimulation/forecast/season/' +
                season + '/disease/' + disease + '/from/' + from + '/to/' + to + '/select/max/groupby/day')
            .pipe(catchError(error => throwError(error)));

    }

    public getRecommendation(commodity: string, recommendationReqParams: RecommendationReqParams): Observable<any> {

        return this.http.post(this.baseURL + '/disease/disease/recommend/commodity/' + commodity, recommendationReqParams)
            .pipe(catchError(error => throwError(error)));

    }

    public getFungicides(): Observable<any> {

        return this.http.get(this.baseURL + '/agrochemicals/products')
            .pipe(catchError(error => throwError(error)));

    }



    public addFieldUser(fieldID: String): Observable<any> {

        return this.http
            .put(this.baseURL + '/landunit/field/user/add', {fieldId: fieldID} )
            .pipe(catchError(error => throwError(error)));
    }

    public removeFieldUser(fieldID: String): Observable<any> {

        return this.http
            .put(this.baseURL + '/landunit/field/user/remove', {fieldId: fieldID})
            .pipe(catchError(error => throwError(error)));
    }


}

